import { createPrivateKey } from "node:crypto";
import { homedir } from "node:os";

import snowflake from "snowflake-sdk";

import { Environment } from "@abacus/common";
import { SecretsManager } from "@abacus/secrets-manager";

import { SnowflakeConfig } from "./types";

export function getConfig(
  processEnv: NodeJS.ProcessEnv = process.env,
): SnowflakeConfig {
  // Account
  const account = processEnv.SNOWFLAKE_ACCOUNT;
  if (account == null) {
    throw new Error("Missing required env variable 'SNOWFLAKE_ACCOUNT'");
  }

  // Database
  const database = processEnv.SNOWFLAKE_DATABASE ?? "orchard_app_reporting_v2";

  // Environment
  let environment = (processEnv.SNOWFLAKE_ENVIRONMENT ??
    processEnv.ENVIRONMENT ??
    processEnv.ENV) as Environment;
  const isEnv = Object.values(Environment).includes(environment);
  if (!isEnv || environment == Environment.Dev) {
    environment = Environment.QA;
  }

  // Private key path
  let privateKeyPath = processEnv.SNOWFLAKE_PRIVATE_KEY_PATH;
  privateKeyPath = privateKeyPath?.replace("~", homedir());

  // Config
  return {
    account,
    authenticator: "SNOWFLAKE_JWT",
    database,
    environment,
    host: processEnv.SNOWFLAKE_HOST,
    privateKey: processEnv.SNOWFLAKE_PRIVATE_KEY,
    privateKeyPass: processEnv.SNOWFLAKE_KEY_PASS,
    privateKeyPath,
    role: processEnv.SNOWFLAKE_ROLE,
    username: processEnv.SNOWFLAKE_USER,
    warehouse: processEnv.SNOWFLAKE_WAREHOUSE,
  };
}

export function getPool(
  config: SnowflakeConfig,
): snowflake.Pool<snowflake.Connection> {
  return snowflake.createPool(config);
}

export async function getPrivateKey(
  secretsManager: SecretsManager,
): Promise<string> {
  // Get key and passphrase
  const key = (await secretsManager.getCred("SNOWFLAKE_PRIVATE_KEY")) as string;
  const passphrase = (await secretsManager.getCred(
    "SNOWFLAKE_KEY_PASSPHRASE",
  )) as string;

  // Decrypt the private key
  const keyObj = createPrivateKey({ key, passphrase });

  // Export the private key as a string in pem format of type pkcs8
  return keyObj.export({ format: "pem", type: "pkcs8" }) as string;
}
